import { useTranslation } from 'react-i18next'
import { Text } from '@mantine/core'
import { RichTextEditor, Link } from '@mantine/tiptap'
import { useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import '@mantine/tiptap/styles.css'

// Edits Planner notes as HTML. The server sanitizes it again before it goes to Microsoft.
export default function NotesEditor({ value, onChange }) {
  const { t } = useTranslation()
  const editor = useEditor({
    extensions: [StarterKit.configure({ link: false, heading: { levels: [2, 3] }, codeBlock: false, horizontalRule: false }), Link.configure({ openOnClick: false, protocols: ['https', 'http', 'mailto'] })],
    content: value,
    immediatelyRender: false,
    onUpdate: ({ editor }) => onChange(editor.isEmpty ? '' : editor.getHTML()),
  })
  return <div>
    <Text component="label" size="sm" fw={500} mb={4} display="block">{t('Omschrijving')}</Text>
    <RichTextEditor editor={editor} className="notes-editor">
      <RichTextEditor.Toolbar>
        <RichTextEditor.ControlsGroup><RichTextEditor.Bold/><RichTextEditor.Italic/><RichTextEditor.Underline/><RichTextEditor.Strikethrough/></RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup><RichTextEditor.BulletList/><RichTextEditor.OrderedList/></RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup><RichTextEditor.Link/><RichTextEditor.Unlink/></RichTextEditor.ControlsGroup>
      </RichTextEditor.Toolbar>
      <RichTextEditor.Content/>
    </RichTextEditor>
  </div>
}
